import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ProBadge from './pro-badge.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    // We want this icon to be a non-square rectangle, so need to
    // override default squaring that happens in our icons.
    return <ProBadge {...validProps} height={undefined} />;
}
SvgComponent.iconName = 'proBadge';

/**
 * @deprecated This is a legacy icon
 */
export const ProBadgeIcon = svgIconWrapper(SvgComponent);
